import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { RateService } from '@prices/services/RateService';
import { SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import {
  isVoiceService,
  isVoiceVerificationService,
  isSmsVerificationService
} from '@utils/services';
import flattenDeep from 'lodash-es/flattenDeep';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'display_name',
      [SORT_DIRECTION]: 'asc',
      trunks: [],
      selectedTrunk: null,
      selectedRate: null,
      serviceName: ''
    },
    mutations: {
      trunks: (state, value) => (state.trunks = value),
      selectedTrunk: (state, value) => (state.selectedTrunk = value),
      serviceName: (state, value) => (state.serviceName = value),
      selectedRate: (state, value) => (state.selectedRate = value)
    },
    getters: {
      trunks: (state) => state.trunks,
      selectedTrunk: (state) => state.selectedTrunk,
      serviceName: (state) => state.serviceName,
      selectedRate: (state, value) => (state.selectedRate = value)
    },
    actions: {
      getData: ({ rootState }, params) => {

        const default_trunk_id = rootState.prices.rates.table.selectedTrunk;
        const service_name = rootState.prices.rates.table.serviceName;
        const user_id = rootState.core.auth.user.id;
        const rate_id = rootState.prices.rates.table.selectedRate;

        if (isVoiceService(service_name)) {
          return RateService.getVoicePricesByTrunk(default_trunk_id, params);
        } else if (isVoiceVerificationService(service_name)) {
          return RateService.getVoiceVerificationPricesByRate(user_id, rate_id, params);
        } else if (isSmsVerificationService(service_name)) {
          return RateService.getSmsVerificationPrices(params);
        } else if (service_name === 'sms') {
          return RateService.getSmsPrices(params);
        } else if (service_name === 'hlr') {
          return RateService.getHlrPrices(params);
        }
      },
      setTrunks({ rootState, commit }, menu) {
        let service_name = rootState.prices.rates.table.serviceName;
        let menuWithSubPoints = menu?.filter((i) => i?.subPoints).map((i) => i.subPoints);
        let trunksByService = flattenDeep(menuWithSubPoints)?.find((i) => i.name === service_name)
          ?.trunks;
        commit('trunks', trunksByService);
      },
      setSelectedTrunk({ commit }, value) {
        commit('selectedTrunk', value);
      },
      setSelectedRate({ commit }, value) {
        commit('selectedRate', value);
      },
      setServiceName({ commit }, value) {
        commit('serviceName', value);
      }
    }
  },
  true
);
